module.exports = __webpack_public_path__ + "img/C2AB7D_4A412E_7A6B4E_F9EDBE-256px.be03f0f0.png";